<template>
  <section class="selector">
    <button
      type="button"
      v-for="option in baseOptions"
      :key="option.value"
      @click="updateSelection(option.value)"
      :class="{ is_active: option.value == selection }"
    >
      {{ option.label }}
    </button>
    <the-dropdown
      v-if="remainingOptions.length > 1"
      @value-change="updateSelection"
      :raw="true"
      :isDark="isDark"
      :switchHover="switchHover"
      :defaultValue="dropboxDefaultValue"
      :options="remainingOptions"
    ></the-dropdown>
  </section>
</template>

<script>
import TheDropdown from './TheDropdown.vue'
export default {
  components: { TheDropdown },
  data() {
    return {
      selection: null,
      isDark: false,
    }
  },
  props: {
    default: null,
    switchHover: {
      type: Boolean,
      value: false,
    },
    options: Array,
    amountOfBaseOptions: {
      type: Number,
      default: 3,
    },
  },
  created() {
    this.selection = this.default
  },
  computed: {
    dropboxDefaultValue() {
      return this.isDark ? this.selection : null
    },
    baseOptions() {
      if (!this.options.length) return []

      return this.options.slice(0, this.amountOfBaseOptions)
    },
    remainingOptions() {
      if (!this.options.length) return []
      const arr = this.options.slice(this.amountOfBaseOptions).reverse()

      arr.push({ label: 'More', value: null })
      arr.reverse()

      return arr
    },
  },
  methods: {
    updateSelection(newValue) {
      if (newValue) this.selection = newValue
    },
  },
  watch: {
    default(newValue) {
      this.selection = newValue
    },
    selection(newValue) {
      this.$emit('value-change', newValue)
      const el = this.remainingOptions.find((v) => {
        return v.value == newValue
      })
      if (el) {
        this.isDark = true
      } else {
        this.isDark = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
section.selector {
  border: 1px solid #000;
  border-radius: 28px;
  padding: 8px;
  display: inline-block;
  margin: 0 auto 10px;

  @include mq($from: tablet) {
    margin: 0 auto 30px;
  }

  &::v-deep {
    .selection_preview {
      padding: 10px 35px 11px 15px;
    }
  }
}

button {
  @include fontStyleNavi;
  display: inline-block;
  width: 40px;
  height: 40px;
  text-align: center;
  border: 0;
  background: transparent;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background: $colorBeigeDark;
  }

  &.is_active {
    background: #000;
    color: #fff;
  }
}
</style>
